import { Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import Link from 'next/link';

import { NotificationReq } from './Sidebar';
import { caloTheme } from '../../assets/themes/calo';
import { useGuardedNavigation } from '../../hooks/useLeaveGuard';
import { KDSPermission } from '../../libs';
import { RoutePaths } from '../../libs/enums';
import NotificationSidebar from '../NotificationSidebar/NotificationSidebar';

export interface Route {
  title: string;
  route: RoutePaths;
  permission: KDSPermission;
  isActive: boolean;
}
interface RouteLinkProps {
  route: Omit<Route, 'permission'>;
  notificationReq: NotificationReq;
  isIndent?: boolean;
}
const RouteLink = ({ route, notificationReq, isIndent }: RouteLinkProps) => {
  const navigate = useGuardedNavigation();

  return (
    <Link className="link" href={route.route} onNavigate={(event) => navigate(route.route, event)}>
      <ListItemText
        sx={{
          m: 0,
          py: 2,
          pr: '2px',
          pl: isIndent ? '50px' : '12px',
          ...(route.isActive ? { backgroundColor: '#E6F3EC', color: 'black' } : {})
        }}
      >
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between'
          }}
        >
          <Typography sx={{ width: '80%', fontFamily: caloTheme.typography.fontFamily }}>{route.title}</Typography>
          {(route.route === RoutePaths.lockTimeChanges || route.route === RoutePaths.logisticsChanges) && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'end',
                ml: '1px',
                mt: '-4px'
              }}
            >
              {route.title === 'Kitchen' ? (
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <NotificationSidebar
                    requestLabel="customer"
                    requestNumber={notificationReq.lockTimeNotificationReq.customerRequest}
                  />
                  <NotificationSidebar requestLabel="cx" requestNumber={notificationReq.lockTimeNotificationReq.cxRequest} />
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <NotificationSidebar
                    requestLabel="customer"
                    requestNumber={notificationReq.logisticsNotificationReq.customerRequest}
                  />
                  <NotificationSidebar requestLabel="cx" requestNumber={notificationReq.logisticsNotificationReq.cxRequest} />
                </Stack>
              )}
            </Box>
          )}
          {route.title === 'Shortage Display' && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'end',
                ml: '1px',
                mt: '-4px'
              }}
            >
              <NotificationSidebar requestLabel="alert" requestNumber={notificationReq.shortagesNotificationReq} />
            </Box>
          )}
        </Stack>
      </ListItemText>
    </Link>
  );
};

export default RouteLink;
